import { render } from "./Accessibility.vue?vue&type=template&id=38d336c0"
import script from "./Accessibility.vue?vue&type=script&lang=js"
export * from "./Accessibility.vue?vue&type=script&lang=js"
script.render = render

export default script